const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'] as const;

export type Days = (typeof days)[number];

export const isValidDay = (value: string): value is Days => days.includes(value as Days);
